export class LandingRoutingPath {
  static readonly LANDING_REGISTER = 'register';
  static readonly LANDING_PAYMENT_CARD = 'register-credit-card';
  static readonly LANDING_HOME = 'old-landing';
}
